import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
   Tables: [],
   Tables_Copy:[],
   selectedTables: [],
   removedTables: [],
   removedColumns: [],
   selectedColumns: [],
   TableStructurePayload: [],
   Changed_Table_alias:{},
   Changed_Column_alias:{},
   total_table: 0,
   loading: false,
   total_pages: 1,
   current_page: 1,
   error_message: false,
   error: true,
   total_record: 0,
   selected_table_count:0,
   vector_column_distinct_selection:[]
};

const Thread_Slice = createSlice({
   name: "Thread",
   initialState,
   reducers: {
      
      update_vector_column_distinct_selection(state, action){
         const { column_name, distinct_extraction } = action.payload;
         
         return {
             ...state,
             vector_column_distinct_selection: {
                 ...state.vector_column_distinct_selection,
                 [column_name]: { distinct_extraction }
             }
         };
     }
      ,start_table_loading(state, actions) {
         state.loading = true;
      },



      update_selected_table_success(state, actions) {

         // console.log(actions.payload, "update_selected_table_success");
         
         // state.loading = false;
         state.error = false;
         state.TableStructurePayload = actions.payload;
      },
      update_selected_table_fail(state, actions) {
         state.loading = false;
         state.error_message = actions.payload;
         state.error = true
      },
      set_Table_List_success(state, actions) {
         const { results, databaseId, count } = actions.payload;
         state.loading = false;
         state.error = false;
         state.count = count
         state.Tables = results.table_details;
         if(results.table_details >= state.Tables_Copy ){
              state.Tables_Copy =results.table_details
         }
         state.current_page = results.current_page != 0 ? results.current_page : 1
         state.total_record = results.total_table_count
         state.total_pages = results.total_pages
         state.selected_table_count=results.selected_table_count
      },

      set_Table_List_fail(state, actions) {
         state.loading = false;
         state.error_message = actions.payload;
         state.error = true
      },

      reset_Table_Data(state, actions) {
         state.Tables = []
         state.Tables_Copy=[]
         state.selectedTables = []
         state.total_table = 0;
         state.error = false
         state.error_message = ""
         state.removedTables = []
         state.removedColumns = []
         state.selectedColumns = []
         state.TableStructurePayload = []
         state.total_table = 0
         state.loading = false
         state.total_pages = 1
         state.current_page = 1
         state.error_message = false
         state.error = true
         state.total_record = 0
      },

      add_to_selected_tables(state, action) {


         state.selectedTables.push(action.payload)
         state.removedTables = state.removedTables.filter((ele) => ele !== action.payload)



      },
      remove_from_selected_table(state, action) {
         state.selectedTables = state.selectedTables.filter((ele) => ele !== action.payload)
         state.removedTables.push(action.payload)

      },


      add_to_selected_Table_Payload(state, action) {
         // console.log(action.payload, "add_to_selected_Table_Payload");
         
         const { table, columns } = action.payload
         let columns_payload = columns.map((ele, i) => {
            return {
               name: ele.column_name,
               type: ele.column_data_type,
               alias: ele.column_name
            }
         });

         state.TableStructurePayload.push({
            table_name: table,
            table_name_alias: table,
            columns: columns_payload
         })
      },



      remove_from_selected_table_payload(state, action) {
         state.TableStructurePayload = state.TableStructurePayload.filter((ele) => ele.table_name !== action.payload)
      },




      add_to_selected_column(state, action) {
         state.selectedColumns.push(action.payload)
         state.removedColumns = state.removedColumns.filter((ele) => ele !== action.payload)
      },
      remove_from_selected_column(state, action) {
         state.selectedColumns = state.selectedColumns.filter((ele) => ele !== action.payload)
         state.removedColumns.push(action.payload)
      },

      add_to_selected_column_payload(state, action) {
         console.log(action.payload, "add_to_selected_column_payload")
         const { table_name, column_name, type , vector_column_distinct } = action.payload;
         const temp_structure_payload = state.TableStructurePayload.map((ele, i) => {
            if (ele.table_name !== table_name) {
               return ele
            } else {
               ele.columns.push({ name: column_name, alias: column_name, type , vector_column_distinct })


               return ele
            }
         })

         state.TableStructurePayload = temp_structure_payload
      },

      remove_from_selected_column_payload(state, action) {
         const { table_name, column_name } = action.payload;
         const temp_structure_payload = state.TableStructurePayload.map((ele, i) => {
            if (ele.table_name !== table_name) {
               return ele
            } else {
               const temp_column = ele.columns.filter((ele) => ele.name !== column_name)
               ele.columns = temp_column

               return ele
            }
         })

         state.TableStructurePayload = temp_structure_payload
      }, 
      change_table_alias(state,action){
          const { table_name , table_alias } = action.payload;
          state.Changed_Table_alias[`${table_name}`] = table_alias

          const temp_structure_payload = state.TableStructurePayload.map((ele, i) => {
            if (ele.table_name !== table_name) {
               return ele
            } else {
               ele.table_name_alias = table_alias


               return ele
            }
         })

         state.TableStructurePayload = temp_structure_payload


      },

      change_column_alias(state,action){
         const { table_name ,column_name, column_alias } = action.payload;
         state.Changed_Column_alias[`${table_name}//${column_name}`] = column_alias

         const temp_structure_payload = state.TableStructurePayload.map((ele, i) => {
           if (ele.table_name !== table_name) {
              return ele
           } else {
               const column_temp = ele.columns.map((col,i)=>{
                       if(col.name === column_name){
                           col.alias = column_alias
                           return col
                       }else{
                          return col
                       }
               }) 

               ele.columns = column_temp
            


              return ele
           }
        })

        state.TableStructurePayload = temp_structure_payload


     },

       set_selected_total_table_count(state, action) {
         const { Selected_tables ,Total_Tables } = action.payload
         state.selected_table_count = Selected_tables
         state.total_record = Total_Tables
         state.loading = false
       }




   },
});

export const {
   update_vector_column_distinct_selection,
   update_selected_table_success,
   update_selected_table_fail,
   set_Table_List_success,
   set_Table_List_fail,
   reset_Table_Data,
   start_table_loading,
   add_to_selected_tables,
   remove_from_selected_table,
   add_to_selected_column,
   remove_from_selected_column,
   add_to_selected_Table_Payload,
   remove_from_selected_table_payload,
   remove_from_selected_column_payload,
   add_to_selected_column_payload,
   change_table_alias,
   change_column_alias,
   set_selected_total_table_count

} = Thread_Slice.actions

export default Thread_Slice.reducer;